export enum FileTable {
  GPSFRAME = 'GPSFRAME',
  STOP_PILE_STATS = 'STOP_PILE_STATS',
  AVG_SEGMENT_TIME = 'AVG_SEGMENT_TIME',
  SEGMENT_TIME = 'SEGMENT_TIME',
  EXTERNAL_STATUSES = 'EXTERNAL_STATUSES',
  EXTERNAL_ENERGY = 'EXTERNAL_ENERGY',
  USER_ACTIVITY = 'USER_ACTIVITY',
  TIMETABLE_FILES = 'TIMETABLE_FILES',
  PUNCTUALITY_REPORT = 'PUNCTUALITY_REPORT',
  STOPPILES_STATISTIC = 'STOPPILES_STATISTIC',
  PLAYLIST_FILE_REPORT = 'PLAYLIST_FILE_REPORT',
  SIL_DATA_UPLOAD_REPORT = 'SIL_DATA_UPLOAD_REPORT',
  TICKETS_REPORT = 'TICKETS_REPORT',
  PASSENGER_COUNT_REPORT = 'PASSENGER_COUNT_REPORT',
  PLAYLIST_FILE_SUMMARY_REPORT = 'PLAYLIST_FILE_SUMMARY_REPORT',
  ACCUMULATED_DATA_REPORT = 'ACCUMULATED_DATA_REPORT'
}

export function getPassengersFileTable(): FileTable[] {
  return [FileTable.PASSENGER_COUNT_REPORT,
  FileTable.TICKETS_REPORT];
}
